export const announcements = [
  {
    "id": "welcome-curated-path",
    "title": {
      "en": "Begin your path",
      "es": "Comienza tu camino",
      "nl": "Begin je pad",
      "pap": "Kuminsá bo kaminda"
    },
    "message": {
      "en": "Begin with the curated path, then continue into the deeper programs, media, and study materials. It is advised to follow all the materials in chronological order for better understanding.",
      "es": "Empieza con el camino guiado y luego continúa hacia los programas, los medios y los materiales de estudio más profundos. Se aconseja seguir todos los materiales en orden cronológico para una mejor comprensión.",
      "nl": "Begin met het samengestelde pad en ga daarna verder met de verdiepende programma's, media en studiematerialen. Het is aan te raden om alle materialen in chronologische volgorde te volgen voor een beter begrip.",
      "pap": "Kuminsá ku e kaminda guiá, despues sigui den e programanan, media i materialnan di estudio mas profundo. Ta rekomendá pa sigui tur e materialnan den òrdu kronológiko pa un mihó komprondementu."
    },
    "status": "active",
    "startDate": "2026-06-26T00:00:00Z",
    "endDate": null,
    "ctaLabel": null,
    "ctaUrl": null,
    "priority": 10
  }
];
